import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const CheckCircle = (props: Icon): React.ReactElement => {
  const [uniqueId] = React.useState(Math.floor(Math.random() * 10000));

  return props.variant === "line" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          id={`check-circle-line-a${uniqueId}`}
          d="M12 4a8 8 0 110 16 8 8 0 010-16zm0 1.333a6.667 6.667 0 100 13.334 6.667 6.667 0 000-13.334zm2.703 4.112c.285.19.376.56.224.858l-.039.067-2.667 4a.667.667 0 01-.857.224l-.067-.04-2-1.333a.667.667 0 01.672-1.148l.067.039 1.445.963L13.78 9.63a.667.667 0 01.924-.185z"
        ></path>
      </defs>
      <g fill={props.color || theme.colors.grey700} fillRule="evenodd">
        <mask
          id={`check-circle-line-b${uniqueId}`}
          fill={props.color || theme.colors.grey700}
        >
          <use xlinkHref={`#check-circle-line-a${uniqueId}`}></use>
        </mask>
        <use
          fill={props.color || theme.colors.grey700}
          fillRule="nonzero"
          xlinkHref={`#check-circle-line-a${uniqueId}`}
        ></use>
        <g
          fill={props.color || theme.colors.grey700}
          mask={`url(#check-circle-line-b${uniqueId})`}
        >
          <path d="M0 0h24v24H0z"></path>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          id={`check-circle-solid-a${uniqueId}`}
          d="M17.657 6.343A8 8 0 106.343 17.66 8 8 0 0017.657 6.343zm-1.818 3.424l-4.406 5.141-3.166-2.375a.667.667 0 01.8-1.066l2.166 1.625 3.594-4.193a.668.668 0 011.012.868z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask
          id={`check-circle-solid-b${uniqueId}`}
          fill={props.color || theme.colors.grey700}
        >
          <use xlinkHref={`#check-circle-solid-a${uniqueId}`}></use>
        </mask>
        <use
          fill={props.color || theme.colors.grey700}
          fillRule="nonzero"
          xlinkHref={`#check-circle-solid-a${uniqueId}`}
        ></use>
      </g>
    </svg>
  );
};
